/* KV Cards JS v3 — recolors any '% OFF' / 'NEW' badge to flat forest green site-wide (custom + AI sections). CTA is now server-rendered in card-product.liquid, so no JS injection needed. */
(function () {
  function styleOffBadges() {
    document.querySelectorAll('span, div, p, em, b, strong').forEach(function (el) {
      if (el.children.length > 0) return;
      if (el.dataset.kvStyled) return;
      var t = (el.textContent || '').trim();
      if (!/^-?\s*\d{1,2}\s*%\s*OFF$/i.test(t) && !/^NEW$/i.test(t)) return;
      if (el.offsetWidth > 220 || el.offsetHeight > 90) return;
      el.dataset.kvStyled = '1';
      el.style.setProperty('background', '#1a3d2a', 'important');
      el.style.setProperty('background-color', '#1a3d2a', 'important');
      el.style.setProperty('background-image', 'none', 'important');
      el.style.setProperty('color', '#fff', 'important');
      el.style.setProperty('border', 'none', 'important');
      el.style.setProperty('border-radius', '6px', 'important');
      el.style.setProperty('padding', '4px 10px', 'important');
      el.style.setProperty('font-size', '11px', 'important');
      el.style.setProperty('font-weight', '800', 'important');
      el.style.setProperty('letter-spacing', '.3px', 'important');
      el.style.setProperty('line-height', '1.4', 'important');
      el.style.setProperty('width', 'auto', 'important');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('animation', 'none', 'important');
      el.style.setProperty('box-shadow', 'none', 'important');
      el.style.setProperty('text-transform', 'uppercase', 'important');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleOffBadges);
  } else {
    styleOffBadges();
  }
  var n = 0;
  var t = setInterval(function () { styleOffBadges(); if (++n > 14) clearInterval(t); }, 700);
})();
